import React from 'react';
import { Loader2 } from 'lucide-react';

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost';
type Size = 'xs' | 'sm' | 'md' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  loading?: boolean;
}

const variantClass: Record<Variant, string> = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  danger: 'btn-danger',
  ghost: 'btn-ghost',
};

const sizeClass: Record<Size, string> = {
  xs: 'btn-xs',
  sm: 'btn-sm',
  md: '',
  lg: '',
};

const lgStyle: React.CSSProperties = { padding: '12px 28px', fontSize: '15px' };

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  children,
  style,
  className,
  ...props
}) => (
  <button
    disabled={disabled || loading}
    className={[variantClass[variant], sizeClass[size], className].filter(Boolean).join(' ')}
    style={size === 'lg' ? { ...lgStyle, ...style } : style}
    {...props}
  >
    {loading ? <Loader2 size={15} style={{ animation: 'spin 0.8s linear infinite' }} /> : children}
  </button>
);
